import React, { useState } from 'react'
import { LogIn } from 'lucide-react'
import { useAuth } from '../auth/AuthContext'

export function Login() {
  const { login, error } = useAuth()
  const [username,    setUsername]    = useState('')
  const [password, setPassword] = useState('')
  const [busy,     setBusy]     = useState(false)
  const [localErr, setLocalErr] = useState<string | null>(null)

  const canSubmit  = username.length > 0 && password.length > 0 && !busy

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!canSubmit) return
    setBusy(true)
    setLocalErr(null)
    try {
      await login(username.trim(), password)
    } catch (err: any) {
      setLocalErr(err?.message ?? 'Login failed')
    } finally {
      setBusy(false)
    }
  }

  const errMsg = localErr ?? error

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0D1B35 0%, #1E293B 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '1.5rem',
    }}>
      <div style={{
        background: '#fff',
        width: '100%', maxWidth: 380,
        borderRadius: '0.5rem',
        boxShadow: '0 12px 40px rgba(0,0,0,0.35)',
        overflow: 'hidden',
      }}>
        {/* Header */}
        <div style={{
          background: '#0D1B35',
          padding: '1.25rem 1.5rem',
          color: '#fff',
          display: 'flex', alignItems: 'center', gap: '0.6rem',
        }}>
            <svg
      viewBox="0 0 220 80"
      height="36"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', flexShrink: 0 }}
    >
      {/* Red lightning bolt shape */}
      <polygon
        points="138,2 175,2 155,38 178,38 130,78 150,42 128,42"
        fill="#D94F4F"
      />
      {/* FIRE in white bold */}
      <text
        x="2" y="62"
        fontFamily="Arial Black, Arial, sans-serif"
        fontWeight="900"
        fontSize="62"
        fill="white"
        letterSpacing="-1"
      >FIRE</text>
      {/* x in white bold, overlapping bolt */}
      <text
        x="133" y="62"
        fontFamily="Arial Black, Arial, sans-serif"
        fontWeight="900"
        fontSize="62"
        fill="white"
      >x</text>
    </svg>
            <div style={{ fontSize: '0.7rem', color: '#94A3B8' }}>
              Future Internet Resilience Exchange · Pilot
            </div>
        </div>

        {/* Form */}
        <form onSubmit={onSubmit} style={{ padding: '1.5rem' }}>
          <h2 style={{
            margin: 0, marginBottom: '1rem',
            fontSize: '1rem', fontWeight: 600, color: '#0F172A',
          }}>
            Sign in to continue
          </h2>

          <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: '#475569', marginBottom: 4 }}>
            Username
          </label>
          <input
            type="text"
            autoComplete="username"
            autoFocus
            value={username}
            onChange={e => setUsername(e.target.value)}
            placeholder="username"
            style={{
              width: '100%', padding: '0.5rem 0.65rem',
              border: '1px solid #CBD5E1', borderRadius: '0.25rem',
              fontSize: '0.875rem', marginBottom: '0.85rem',
              boxSizing: 'border-box',
            }}
          />

          <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: '#475569', marginBottom: 4 }}>
            Password
          </label>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="••••••••"
            style={{
              width: '100%', padding: '0.5rem 0.65rem',
              border: '1px solid #CBD5E1', borderRadius: '0.25rem',
              fontSize: '0.875rem', marginBottom: '0.85rem',
              boxSizing: 'border-box',
            }}
          />

          {errMsg && (
            <div style={{
              padding: '0.5rem 0.65rem', marginBottom: '0.85rem',
              background: '#FEF2F2', color: '#991B1B',
              border: '1px solid #FECACA', borderRadius: '0.25rem',
              fontSize: '0.8rem',
            }}>
              {errMsg}
            </div>
          )}

          <button
            type="submit"
            disabled={!canSubmit}
            style={{
              width: '100%', padding: '0.55rem 0.75rem',
              borderRadius: '0.25rem', border: 'none',
              fontSize: '0.875rem', fontWeight: 600,
              background: canSubmit ? '#0D9488' : '#94A3B8',
              color: '#fff', cursor: canSubmit ? 'pointer' : 'not-allowed',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              gap: '0.4rem', transition: 'background 0.15s',
            }}
          >
            <LogIn size={14} />
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div style={{
          padding: '0.55rem 1.5rem',
          background: '#F8FAFC',
          fontSize: '0.65rem', color: '#94A3B8',
          borderTop: '1px solid #E2E8F0',
          textAlign: 'center',
        }}>
          CRPO-GC5-ETH-002 · Singapore-ETH Centre · Chain 13371
        </div>
      </div>
    </div>
  )
}